module.exports = __webpack_public_path__ + "img/vue-logo.a43db403.png";